var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLockOpen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0001 15.5833C12.0084 15.5833 12.8334 14.7583 12.8334 13.75C12.8334 12.7417 12.0084 11.9167 11.0001 11.9167C9.99175 11.9167 9.16675 12.7417 9.16675 13.75C9.16675 14.7583 9.99175 15.5833 11.0001 15.5833ZM16.5001 7.33332H15.5834V5.49999C15.5834 2.96999 13.5301 0.916656 11.0001 0.916656C8.47008 0.916656 6.41675 2.96999 6.41675 5.49999H8.15841C8.15841 3.93249 9.43258 2.65832 11.0001 2.65832C12.5676 2.65832 13.8417 3.93249 13.8417 5.49999V7.33332H5.50008C4.49175 7.33332 3.66675 8.15832 3.66675 9.16666V18.3333C3.66675 19.3417 4.49175 20.1667 5.50008 20.1667H16.5001C17.5084 20.1667 18.3334 19.3417 18.3334 18.3333V9.16666C18.3334 8.15832 17.5084 7.33332 16.5001 7.33332ZM16.5001 18.3333H5.50008V9.16666H16.5001V18.3333Z",
    fill: "#201D1D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockOpen);
export default __webpack_public_path__ + "static/media/lock-open.ccca6b95860800a077b900c2c09b2488.svg";
export { ForwardRef as ReactComponent };